export function toIntOrDefault (value, def) {
  let val = parseInt(value, 10)
  return isNaN(val) ? def : val
}

export function toFloatOrDefault (value, def) {
  let val = parseFloat(value, 10)
  return isNaN(val) ? def : val
}

export function IntToStringOrDefault (value, def) {
  return '' + toIntOrDefault(value, def)
}



// WEBPACK FOOTER //
// ./src/utilities/numbers.js